export type PasswordStrength = 0 | 1 | 2 | 3 | 4;

/**
 * Four-level meter for the sign-up and reset forms. Guidance only: the server's rule is just the
 * minimum length (Better Auth), so this never blocks submit.
 *  0 empty - 1 too short or weak - 2 fair - 3 strong - 4 very strong
 */
export function passwordStrength(password: string): PasswordStrength {
  if (!password) return 0;
  if (password.length < 8) return 1;
  const classes = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter((re) => re.test(password)).length;
  const hasDigitOrSymbol = /[\d]|[^A-Za-z0-9]/.test(password);
  if (classes <= 1 || !hasDigitOrSymbol) return 2;
  if (password.length >= 12 && classes >= 4) return 4;
  return 3;
}

export const STRENGTH_COPY: Record<PasswordStrength, string> = {
  0: '',
  1: 'Too short — use at least 8 characters',
  2: 'Fair — add a number or symbol',
  3: 'Strong — add a symbol to make it even stronger',
  4: 'Very strong',
};
